export const APP_SENTRYDSN: string = 'https://71736bdacaed4036ac6201d47f422a59@o438327.ingest.sentry.io/5414387';
export const REACT_APP_ENV: string = 'prod';
